import {TopEleven} from '../resources/TopEleven';
import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';

/**
 * This event can be fired to indicate that some data as requested via the {@see TopElevensExportRequested} event is
 * available and can be processed.
 */
export class TopElevensExportAvailable extends EntityExportAvailableEvent<TopEleven> {
}
